import React from "react";

interface IconProps {
  color: string;
  className: string;
}

const Icon: React.FC<IconProps> = ({ color, className }) => (
  <svg className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.99996 1.6665C5.39996 1.6665 1.66663 5.39984 1.66663 9.99984C1.66663 14.5998 5.39996 18.3332 9.99996 18.3332C14.6 18.3332 18.3333 14.5998 18.3333 9.99984C18.3333 5.39984 14.6 1.6665 9.99996 1.6665ZM9.99996 16.6665C6.32496 16.6665 3.33329 13.6748 3.33329 9.99984C3.33329 6.32484 6.32496 3.33317 9.99996 3.33317C13.675 3.33317 16.6666 6.32484 16.6666 9.99984C16.6666 13.6748 13.675 16.6665 9.99996 16.6665ZM9.16663 13.3332H10.8333V14.9998H9.16663V13.3332ZM10.5083 5.03317C8.79163 4.78317 7.27496 5.8415 6.81663 7.35817C6.66663 7.8415 7.03329 8.33317 7.54163 8.33317H7.70829C8.04996 8.33317 8.32496 8.0915 8.44163 7.77484C8.70829 7.03317 9.49996 6.52484 10.3583 6.70817C11.15 6.87484 11.7333 7.64984 11.6666 8.45817C11.5833 9.57484 10.3166 9.8165 9.62496 10.8582C9.62496 10.8665 9.61663 10.8665 9.61663 10.8748C9.60829 10.8915 9.59996 10.8998 9.59163 10.9165C9.51663 11.0415 9.44163 11.1832 9.38329 11.3332C9.37496 11.3582 9.35829 11.3748 9.34996 11.3998C9.34163 11.4165 9.34163 11.4332 9.33329 11.4582C9.23329 11.7415 9.16663 12.0832 9.16663 12.4998H10.8333C10.8333 12.1498 10.925 11.8582 11.0666 11.6082C11.0833 11.5832 11.0916 11.5582 11.1083 11.5332C11.175 11.4165 11.2583 11.3082 11.3416 11.2082C11.35 11.1998 11.3583 11.1832 11.3666 11.1748C11.45 11.0748 11.5416 10.9832 11.6416 10.8915C12.4416 10.1332 13.525 9.5165 13.3 7.92484C13.1 6.47484 11.9583 5.24984 10.5083 5.03317Z"
    />
  </svg>
);

export const HelpIcon: React.FC<IconProps> = ({ color, className }) => {
  return <Icon className={className} color={color} />;
};
